import React, { useEffect, useRef, useState } from 'react'
import styled from '~/app/components/styled'
import { Renderable } from './index'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * SubTitleDescription component
 * author: soojin.oh
 */

// type definitions
export type SubTitleDescriptionProps = {
  title: Renderable
  description?: Renderable
  isShow?: boolean
}

// styled components
const CollapseContainer = styled.div<{ height: number }>`
  overflow: hidden;
  min-height: 100%;
  height: ${({ height }) => `${height}px`};
  -webkit-transition: height 0.3s ease-in-out;
  transition: height 0.3s ease-in-out;
`
const Content = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 2rem;
  ${Typography('body2').regular};
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.gray600};
`
const Description = styled.div`
  color: ${({ theme }) => theme.color.gray600};
`

// SubTitleDescription component
const SubTitleDescription: React.FunctionComponent<SubTitleDescriptionProps> = function ({
  title,
  description,
  isShow = true,
}) {
  const [height, setHeight] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setHeight(isShow ? (ref.current?.clientHeight ?? 0) : 0)
  })

  return (
    <CollapseContainer height={height}>
      <Content ref={ref}>
        <Title>• {title}</Title>
        {description && <Description>{description}</Description>}
      </Content>
    </CollapseContainer>
  )
}

export default SubTitleDescription
